import React from 'react'
import { Grid } from 'semantic-ui-react'
import { css } from 'emotion';

export default function CompactGrid(props) {
  return (
    <Grid {...props} className={style} />
  )
}

const style = css`
  &.ui.grid > .row {
    padding: 0px !important;
    margin-top: -.3em;
  }
`


// WEBPACK FOOTER //
// ./components/custom/CompactGrid.js